import ExpanderCollapser from '@/components/ExpanderCollapser/ExpanderCollapser.tsx'
import { SEO_SPACER } from '@/lib/seoSpacer.ts'
import * as React from 'react'
import styles from './FAQ.module.scss'

export interface FAQProps {
	// the content to be displayed in the expander/collapser
	children: React.ReactNode
	// the title of the FAQ
	title: string
}

export const FAQ: React.FC<FAQProps> = ({ children, title }) => {
	const topButton = (
		<span>
			<img src="/img/plus.svg" alt="plus icon" width="20" height="32" />
			{title}
			{SEO_SPACER}
		</span>
	)

	const bottomButton = (
		<span>
			<img src="/img/minus.svg" alt="minus icon" width="20" height="32" />
			{title}
			{SEO_SPACER}
		</span>
	)
	return (
		<div className={styles.faq}>
			<ExpanderCollapser
				toggleClass={''}
				animationTime="0.3s"
				topButton={{
					initState: topButton,
					altState: bottomButton,
					persist: true,
				}}
				defaultOpen={false}
			>
				{children}
				{SEO_SPACER}
			</ExpanderCollapser>
		</div>
	)
}
